import { List, Create, Edit, View, MyPending } from "../Components/index.js";

export default [
    {
        path: "/canteen/note-sheet",
        component: List,
        name: "canteen.note-sheet",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/canteen/note-sheet/create",
        component: Create,
        name: "canteen.note-sheet.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/canteen/note-sheet/:id/edit",
        component: Edit,
        name: "canteen.note-sheet.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/canteen/note-sheet/:id/view",
        component: View,
        name: "canteen.note-sheet.view",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/canteen/note-sheet-my-pending",
        component: MyPending,
        name: "canteen-my-note-sheet",
        meta: {
            requiresAuth: true,
        },
    },
];
